<template>
  <section
    class="RunsPage"
    data-theme="light"
    :aria-busy="isFetching"
  >
    <Transition name="fade">
      <RunCarouselView
        v-if="currentRuns.length > 0"
      />
      <ErrorEmptyState
        v-else-if="hasError"
        data-testid="errorEmptyState"
        @retry="fetchRuns()"
      />
      <EmptyState
        v-else-if="!isFetching"
        data-testid="noRunsemptyState"
        iconName="personRunning"
      >
        <h2>Your crew has nothing scheduled</h2>
        <p v-if="isCommissioner">
          Schedule a run using the button in the bottom right.
        </p>
        <p v-else>
          Ask your commish to schedule a run.
        </p>
      </EmptyState>
    </Transition>
  </section>
</template>

<script lang="ts" setup>
import EmptyState from "@/components/EmptyState.vue";
import ErrorEmptyState from "@/components/ErrorEmptyState.vue";
import useVisibilityChange from "@/composables/useVisibilityChange";
import useAuthStore from "@/stores/useAuthStore";
import useRunCarouselStore from "@/stores/useRunCarouselStore";
import RunCarouselView from "@/views/RunCarouselView.vue";
import { useSeoMeta } from "@unhead/vue";
import { storeToRefs } from "pinia";
import { onBeforeMount, ref } from "vue";

useSeoMeta({
  title: "Runs",
});

const {
  isCommissioner,
} = storeToRefs(useAuthStore());

const {
  currentRuns,
} = storeToRefs(useRunCarouselStore());

const {
  fetchCurrentRuns,
} = useRunCarouselStore();

const isFetching = ref(false);
const hasError = ref(false);

useVisibilityChange(handleVisibilityChange);

onBeforeMount(async () => {
  await fetchRuns();
});

async function fetchRuns () {
  if (isFetching.value) return;

  isFetching.value = true;
  hasError.value = false;

  const [error] = await fetchCurrentRuns();
  if (error) hasError.value = true;

  isFetching.value = false;
}

function handleVisibilityChange (isAppVisible: boolean) {
  if (isAppVisible) fetchRuns();
}
</script>

<style lang="scss" scoped>
.RunsPage {
  display: grid;
  align-items: start;
  height: 100%;

  background-color: var(--themeColorSurface);
}
</style>
